import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Payment } from '@payment/const';
import { CUSTOM_ICON_TYPE } from '@shared/models';

@Component({
  selector: 'sd-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPaymentComponent {
  @Input() payment: Payment;

  @Output() removePayment = new EventEmitter<void>();

  iconType = CUSTOM_ICON_TYPE;
}
